import gql from 'graphql-tag'

export const CHECK_UPLOAD_SCHEDULED_SHIFT_GROUPS = gql`
  mutation CHECK_UPLOAD_SCHEDULED_SHIFT_GROUPS(
    $records: [ScheduledShiftGroupCsvRecord!]!
    $isRecruitment: Boolean!
  ) {
    staffCheckUploadScheduledShiftGroups(
      records: $records
      isRecruitment: $isRecruitment
    ) {
      rows {
        index
        errorMessage
      }
      groups {
        groupKey
        rowIndexes
        name
        action
        existingGroupId
        argsJson
      }
    }
  }
`

// 画面の定期募集作成と同じ mutation。CSV では募集待ちの医師へのメールを送らない
export const CSV_CREATE_RECRUITMENT_GROUP = gql`
  mutation CSV_CREATE_RECRUITMENT_GROUP(
    $dataTime: DayOfWeekInput!
    $isHolidays: [String!]
    $data: ScheduledAvailableShiftGroupCreateInput!
    $isPublished: Boolean!
    $repeatSetting: RepeatSettingTypes
    $dateMatrix: String
    $comment: String
    $staffComments: [WorkScheduleCommentCreateInput!]
    $numberOfRooms: Int!
    $recruitmentCategory: [AvailableShiftRecruitmentCreateInput!]
    $isSetIndividually: Boolean!
    $isHolidayRepeat: Boolean
    $isEarlySpecial: Boolean
    $isDoubleRecruitment: Boolean
    $skipWaitingRecruitmentMail: Boolean
  ) {
    staffCreateScheduledAvailableShiftGroupRecruitment(
      dataTime: $dataTime
      isHolidays: $isHolidays
      data: $data
      isPublished: $isPublished
      repeatSetting: $repeatSetting
      dateMatrix: $dateMatrix
      comment: $comment
      staffComments: $staffComments
      numberOfRooms: $numberOfRooms
      recruitmentCategory: $recruitmentCategory
      isSetIndividually: $isSetIndividually
      isHolidayRepeat: $isHolidayRepeat
      isEarlySpecial: $isEarlySpecial
      isDoubleRecruitment: $isDoubleRecruitment
      skipWaitingRecruitmentMail: $skipWaitingRecruitmentMail
    ) {
      id
    }
  }
`

// 画面の定期確定作成と同じ mutation。mailContent を渡さないので、医師へのメールは送らない
export const CSV_CREATE_FIXED_GROUP = gql`
  mutation CSV_CREATE_FIXED_GROUP(
    $doctorId: ID!
    $data: ScheduledAvailableShiftGroupCreateInput!
    $dataTime: DayOfWeekInput!
    $isHolidays: [String!]
    $repeatSetting: RepeatSettingTypes
    $dateMatrix: String
    $comment: String
    $staffComments: [WorkScheduleCommentCreateInput!]
    $isPublished: Boolean
    $isHolidayRepeat: Boolean
  ) {
    staffCreateScheduledAvailableShiftGroup(
      doctorId: $doctorId
      data: $data
      dataTime: $dataTime
      isHolidays: $isHolidays
      repeatSetting: $repeatSetting
      dateMatrix: $dateMatrix
      comment: $comment
      staffComments: $staffComments
      isPublished: $isPublished
      isHolidayRepeat: $isHolidayRepeat
    ) {
      id
    }
  }
`

export const CSV_DELETE_RECRUITMENT_GROUP = gql`
  mutation CSV_DELETE_RECRUITMENT_GROUP($scheduledAvailableShiftGroupId: ID!) {
    staffDeleteScheduledAvailableShiftGroupRecruitment(
      scheduledAvailableShiftGroupId: $scheduledAvailableShiftGroupId
    )
  }
`

// mailContent を渡さないので、医師へのメールは送らない
export const CSV_DELETE_FIXED_GROUP = gql`
  mutation CSV_DELETE_FIXED_GROUP($scheduledAvailableShiftGroupId: ID!) {
    staffDeleteScheduledAvailableShiftGroup(
      scheduledAvailableShiftGroupId: $scheduledAvailableShiftGroupId
    )
  }
`
